// extracted by mini-css-extract-plugin
module.exports = {"loader-circle":"loader_loader-circle__IHDKi","spin":"loader_spin__ui7nr"};